module.exports = __webpack_public_path__ + "static/weareusing-7b22bf4c719a2c5902ad15971699920f.png";